"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumVoovMeeting = void 0;
/**
 * VooV详情页常量
 */
var EnumVoovMeeting;
(function (EnumVoovMeeting) {
    EnumVoovMeeting["DETAIL_PREFIX"] = "https://voovmeeting.com/detail.html";
    EnumVoovMeeting["PMI_PREFIX"] = "https://voovmeeting.com/pmi-detail.html";
    // 测试环境
    EnumVoovMeeting["TEST_DETAIL_PREFIX"] = "https://test.web.voovmeeting.com/detail.html";
    EnumVoovMeeting["TEST_PMI_PREFIX"] = "https://test.web.voovmeeting.com/pmi-detail.html";
    // 下载地址
    EnumVoovMeeting["DOWNLOAD_URL"] = "https://www.voovmeeting.com/download-center.html?from=1001";
    // 测试的 下载地址
    EnumVoovMeeting["TEST_DOWNLOAD_URL"] = "https://test.web.voovmeeting.com/download-center.html?from=1001";
    // 唤起页面
    EnumVoovMeeting["APP_STORE_TRANSFER"] = "https://meeting.tencent.com/df/en/launch-app.html";
})(EnumVoovMeeting = exports.EnumVoovMeeting || (exports.EnumVoovMeeting = {}));
//# sourceMappingURL=voov.js.map